import { Injectable } from '@angular/core';
import { appConfig } from '../app.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WebsiteService {

  readonly base_address: string = appConfig.apiUrl + 'admin/';

  constructor(private httpclient: HttpClient) { }

  // ContactUs(contact) {
  //   const headers = new HttpHeaders()
  //     .set('Content-Type', 'application/json');

  //   return this.httpclient.post(this.base_address + 'ContactUs', contact, { headers, responseType: 'text' })
  // }

  ContactUs(contact) {
    const headers = new HttpHeaders();
      //.set('Content-Type', 'multipart/form-data');

      console.log(contact);
    return this.httpclient.post(this.base_address + 'ContactUs', contact, { headers, responseType: 'text' })
  }

  GetKpiBcResults(KpiId, Year, Quarter) {
    return this.httpclient.get(this.base_address + `GetKpiBcResults?KpiId=${KpiId}&Year=${Year}&Quarter=${Quarter}`);
  }

  GetBcKpiResults(BCId, Year, Quarter, Output) {
    return this.httpclient.get(this.base_address + `GetBcKpiResults?BCId=${BCId}&Year=${Year}&Quarter=${Quarter}&Output=${Output}`);
  }

  GetBcKpiDetails(BCId, KpiId, Year, Quarter) {
    return this.httpclient.get(this.base_address + `GetBcKpiDetails?BCId=${BCId}&KpiId=${KpiId}&Year=${Year}&Quarter=${Quarter}`);
  }

  DownloadEvidence(docId) {
    return this.httpclient.get(this.base_address + 'DownloadEvidence?FileId=' + docId)
  }

  DownloadRegionalEvidence(docId) {
    return this.httpclient.get(this.base_address + 'DownloadRegionalEvidence?FileId=' + docId)
  }

  GetBcDashboard(BCId, Year, Quarter) {
    return this.httpclient.get(this.base_address + `GetBcDashboard?BCId=${BCId}&Year=${Year}&Quarter=${Quarter}`);
  }

  GetKpiDashboard(KpiId, Year, Quarter) {
    return this.httpclient.get(this.base_address + `GetKpiDashboard?KpiId=${KpiId}&Year=${Year}&Quarter=${Quarter}`);
  }

  GetBcTracker(BCId) {
    return this.httpclient.get(this.base_address + `GetBcValidationTracker?BCId=${BCId}`);
  }

  GetKpiTracker(KpiId) {
    return this.httpclient.get(this.base_address + `GetKpiValidationTracker?KpiId=${KpiId}`);
  }
}
